import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { StyledInput, StyledSwitch, StyledWrapper } from './Switch.style';
export function Switch({ name, checked, onChange, size = 'Medium', }) {
    const [isChecked, setIsChecked] = useState(checked);
    const onChangeHandler = () => {
        setIsChecked(!isChecked);
        onChange === null || onChange === void 0 ? void 0 : onChange(!isChecked);
    };
    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);
    return (_jsxs(StyledWrapper, { size: size, children: [_jsx(StyledInput, { inputSize: size, checked: isChecked, name: name, type: "checkbox", onChange: onChangeHandler }), _jsx(StyledSwitch, { size: size })] }));
}
//# sourceMappingURL=Switch.js.map